import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseResizableComponent } from '@src/app/modules/base';
import { PreviousRouteService } from '@src/core/services';
import { ViewMode } from '@src/models';

@Component({
  selector: 'lp-product-request-info-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductRequestInfoHeaderComponent extends BaseResizableComponent {
  private readonly previousRouteService = inject(PreviousRouteService);
  private readonly translateService = inject(TranslateService);

  @Input() id?: string;
  @Input() title?: string;
  @Input() mode?: ViewMode;
  @Input() allowedEditing: boolean | null = false;
  @Input() allowedDeleting: boolean | null = false;

  @Output() startEdit = new EventEmitter<void>();
  @Output() cancelEdit = new EventEmitter<void>();
  @Output() startDelete = new EventEmitter<void>();

  onClickBackButton() {
    if (this.mode === 'edit' || this.mode === 'create') {
      this.cancelEdit.emit();
      return;
    }

    this.previousRouteService.back('/loyalty');
  }

  get headerTitle(): string {
    if (this.title) {
      return this.title;
    }

    if (this.mode === 'create') {
      return this.translateService.instant('components.lpProductRequestInfo.labels.createHeader');
    }

    if (this.mode === 'edit') {
      return this.translateService.instant('components.lpProductRequestInfo.labels.editHeader');
    }

    return '';
  }
}
